import { HTMLProps, createElement, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type Variant = keyof typeof STYLES;

interface TextMonoProps extends HTMLProps<HTMLElement> {
  variant: Variant;
  as?: string;
  family?: "mono";
  weight?: "regular" | "bold";
}

interface TextSansProps extends HTMLProps<HTMLElement> {
  variant: Variant;
  as?: string;
  family?: "sans";
  weight?: "thin" | "regular" | "bold" | "black";
}

export type TextProps = TextMonoProps | TextSansProps;

const STYLES = {
  subtitle1: "uppercase text-base tracking-normal",
  subtitle2: "uppercase text-xs tracking-normal",
  body1: "text-base tracking-normal",
  body2: "text-xs tracking-normal",
  button: "uppercase text-base tracking-normal",
  caption: "uppercase text-xs tracking-normal",
  detail: "uppercase text-2xs tracking-[0em]",
  avatarLetter: "uppercase text-xl tracking-normal",
} as const;

const FONT_FAMILY = {
  sans: "font-sans",
  mono: "font-mono",
} as const;

const FONT_WEIGHT = {
  thin: "font-thin",
  regular: "font-normal",
  bold: "font-bold",
  black: "font-black",
} as const;

export const SupText = forwardRef<HTMLElement, TextProps>(({ variant, as, family = "mono", weight = "regular", children, className, ...restProps }, ref) => {
  return createElement(
    as ?? "p",
    {
      ...restProps,
      ref,
      className: twMerge(STYLES[variant], FONT_FAMILY[family], FONT_WEIGHT[weight], "leading-none antialiased", className),
    },
    children
  );
});

SupText.displayName = "SupText";
